import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private privateStorage: Storage | null = null;
  constructor(private storage: Storage) {
    this.init();
  }

  async init(): Promise<Storage> {
    const s = await this.storage.create();
    this.privateStorage = s;
    return s;
  }

  async set(key: string, value) {
    //En caso de que aún no esté instanciada la BD entonces se crear con el init
    if (this.privateStorage === null) {
      await this.init();
    }
    await this.privateStorage.set(key, value);
  }

  async get<T>(key: string): Promise<T | null> {
    //En caso de que aún no esté instanciada la BD entonces se crear con el init
    if (this.privateStorage === null) {
      await this.init();
    }
    return this.privateStorage.get(key);
  }

  async remove(key: string): Promise<any> {
    if (this.privateStorage === null) {
      await this.init();
    }
    return this.privateStorage.remove(key);
  }

  async clear(): Promise<any> {
    if (this.privateStorage === null) {
      await this.init();
    }
    return this.privateStorage.clear();
  }
}
